export default {
    dependencies: ['$element', 'trackingservice', 'notificationservice'],
    callable(element, trackingService, notificationservice) {
        element.addEventListener(
            'click',
            trackingService.trackEvent.bind(
                trackingService,
                'notifications.main-menu-notification.click',
                'success',
                ''
            )
        );

        const unseenId = element.getAttribute('data-notification-mark-read-id');
        if (unseenId) {
            element.addEventListener(
                'click',
                notificationservice.markIdAsSeen.bind(
                    notificationservice,
                    unseenId
                )
            );
        }

        const type = element.getAttribute('data-notification-type');

        if (type === 'pricechange') {
            element.addEventListener('click', () => {
                trackingService.trackEventObject({
                    analyticsName: 'notifications.price-change-ad.click',
                    eventFlags: 'start,success',
                    kpi: 'activity',
                    ecType: 'USER',
                    ecCategory: 'notifications.price-change-ad.click',
                });
            });
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/handleNotificationClick.js